<script setup lang="ts">
    import { LastModifiedItem } from '../DashboardTypes';
    import { injectorAccessInjectionKey } from '@cwd/lib/provider-keys';
    import { inject } from 'vue';
    import { formatDateTime } from '@shared/utils/formatDateTime';
    import { DashboardAccess } from '@views/Dashboard/Dashboard.access';
    import IssueSubject from '@cwd/Views/Issues/IssueSubject.vue';

    const injectorAccess = inject(injectorAccessInjectionKey)!;
    const dashboardAccess: DashboardAccess = injectorAccess.injector.get(DashboardAccess);

    const props = defineProps<{ item: LastModifiedItem }>();
</script>

<template>
    <template v-if="item.Type === 'Issue'" v-require-scope="{ Feature: 'Issues', Permission: Permissions.Read }">
        <h4 class="item-heading">
            <a :href="item.Url">
                <IssueSubject :subject="item.Title" :dynamic-subject="item.DynamicSubject" />
            </a>
            <button
                type="button"
                class="btn btn-subtle btn-xs"
                v-tooltip.top="$Resources.IssuePreviewButton"
                @click="dashboardAccess.previewObject(item.Url + '?preview=true')">
                <span class="glyphicon glyphicon-eye-open" aria-hidden="true"></span>
            </button>
        </h4>
        <p v-if="item.Description" v-text="item.Description"></p>
        <p class="meta">
            <span class="m-md-r">
                <span class="glyphicon glyphicon-envelope"></span>
                {{ $Resources.ItemTypeIssue }}
            </span>
            <span class="m-md-r">
                <span class="glyphicon glyphicon-time"></span>
                <span v-text="formatDateTime(item.LastModified)"></span>
                <!-- <span v-time-ago="item.LastModified"></span> -->
            </span>
            <span class="m-md-r" v-if="item.LastModifiedBy">
                <span class="glyphicon glyphicon-user"></span>
                <span v-text="item.LastModifiedBy.Name"></span>
            </span>
        </p>
    </template>

    <template v-if="item.Type === 'Survey'" v-require-scope="{ Feature: 'Surveys', Permission: Permissions.Read }">
        <h4>
            <a :href="item.Url" v-text="item.Title ? item.Title : $Resources.NoTitlePlaceholder"></a>
            <button
                type="button"
                class="btn btn-subtle btn-xs m-0-b"
                v-tooltip.top="$Resources.IssuePreviewButton"
                @click="dashboardAccess.previewObject(item.Url + '?preview=true')">
                <span class="glyphicon glyphicon-eye-open" aria-hidden="true"></span>
            </button>
        </h4>
        <p v-if="item.Description" v-text="item.Description"></p>
        <p class="meta">
            <span class="m-md-r">
                <span class="glyphicon glyphicon-th-list"></span>
                {{ $Resources.ItemTypeSurvey }}
            </span>
            <span class="m-md-r">
                <span class="glyphicon glyphicon-time"></span>
                <span v-text="formatDateTime(item.LastModified)"></span>
                <!-- <span v-time-ago="item.LastModified"></span> -->
            </span>
            <span class="m-md-r" v-if="item.LastModifiedBy">
                <span class="glyphicon glyphicon-user"></span>
                <span v-text="item.LastModifiedBy.Name"></span>
            </span>
        </p>
    </template>

    <template v-if="item.Type === 'Event2Dto'" v-require-scope="{ Feature: 'Events', Permission: Permissions.Read }">
        <h4>
            <RouterLink :to="item.Url">{{ item.Title || $Resources.NoTitlePlaceholder }}</RouterLink>
            <button
                type="button"
                class="btn btn-subtle btn-xs m-0-b"
                v-tooltip.top="$Resources.IssuePreviewButton"
                @click="dashboardAccess.previewObject(item.Url + '?preview=true')">
                <span class="glyphicon glyphicon-eye-open" aria-hidden="true"></span>
            </button>
        </h4>
        <p v-if="item.Description" v-text="item.Description"></p>
        <p class="meta">
            <span class="m-md-r">
                <span class="glyphicon glyphicon-calendar"></span>
                {{ $Resources.ItemTypeEvent }}
            </span>
            <span class="m-md-r">
                <span class="glyphicon glyphicon-time"></span>
                <span v-text="formatDateTime(item.LastModified)"></span>
                <!-- <span v-time-ago="item.LastModified"></span> -->
            </span>
            <span class="m-md-r" v-if="item.LastModifiedBy">
                <span class="glyphicon glyphicon-user"></span>
                <span v-text="item.LastModifiedBy.Name"></span>
            </span>
        </p>
    </template>

    <template v-if="item.Type === 'SmsMessageDto'" v-require-scope="{ Feature: 'Sms', Permission: Permissions.Read }">
        <h4>
            <a :href="item.Url" v-text="item.Title ? item.Title : $Resources.NoTitlePlaceholder"></a>
        </h4>
        <p v-if="item.Description" v-text="item.Description"></p>
        <p class="meta">
            <span class="m-md-r">
                <span class="glyphicon glyphicon-phone"></span>
                {{ $Resources.ItemTypeSmsMessage }}
            </span>
            <span class="m-md-r">
                <span class="glyphicon glyphicon-time"></span>
                <span v-text="formatDateTime(item.LastModified)"></span>
                <!-- <span v-time-ago="item.LastModified"></span> -->
            </span>
            <span class="m-md-r" v-if="item.LastModifiedBy">
                <span class="glyphicon glyphicon-user"></span>
                <span v-text="item.LastModifiedBy.Name"></span>
            </span>
        </p>
    </template>
</template>

<style scoped></style>
